import { render, staticRenderFns } from "./stats.vue?vue&type=template&id=8c87d222&scoped=true&"
import script from "./stats.vue?vue&type=script&lang=js&"
export * from "./stats.vue?vue&type=script&lang=js&"
import style0 from "./stats.vue?vue&type=style&index=0&id=8c87d222&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c87d222",
  null
  
)

/* custom blocks */
import block0 from "./stats.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports